import React from 'react';
import { Modal, makeStyles, Theme, createStyles, Backdrop, Fade } from '@material-ui/core';

import { CreateCityForm } from './CreateCityForm';
import { useCancelRoute } from 'hooks';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    form: {
      backgroundColor: theme.palette.background.paper,
      border: '0px',
      borderRadius: '2px',
      boxShadow: theme.shadows[5],
    },
  })
);

export const CreateCityPage = () => {
  const classes = useStyles();

  const { onCancel } = useCancelRoute('/cities');

  return (
    <Modal
      open={true}
      onClose={onCancel}
      aria-labelledby="Добавить город"
      aria-describedby="Модальное окно с формой добавления города"
      className={classes.modal}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={true}>
        <div className={classes.form}>
          <CreateCityForm onClose={onCancel} />
        </div>
      </Fade>
    </Modal>
  );
};
